import { TReportTypesData, TReports } from '@ts/common-types';
import React from 'react'
import { ReactComponent as DeleteOutlined } from "@images/circle_xmark.svg";
import { titleCase } from '@/ts/utils';


interface IReportsTemplate { reports: Array<TReports>, handleDeleteReport: (id: string) => void, reportTypesData: Array<TReportTypesData>}

const ReportsTemplate: React.FC<IReportsTemplate> = ({ reports, handleDeleteReport, reportTypesData }) => {
    return (
        <>
            <div className="row text-center" style={{ fontWeight: "600" }}>
                <div className="col">Report ID</div>
                <div className="col">Report Name</div>
                <div className="col">Report Type</div>
                <div className="col">Action</div>
            </div>
            <div className="card my-2 report-overflow-container">
                {reports.map((report: TReports) => (
                    <div key={report.id} className="row text-center my-2">
                        <span
                            className="col ellipsis"
                            style={{ width: "8ch" }}
                            title={report.id}
                        >
                            {report.id}
                        </span>
                        <span
                            className="col ellipsis"
                            style={{ width: "8ch" }}
                            title={report.id}
                        >
                            {report.name}
                        </span>
                        <span className="col">
                            {titleCase(
                                reportTypesData.filter(
                                    (type: TReportTypesData) =>
                                        type.id === report.type
                                )[0].name
                            )}
                        </span>
                        <span className="col d-flex justify-content-center">
                            <DeleteOutlined
                                role="button"
                                height={20}
                                width={20}
                                fill="#d9534f"
                                onClick={() => handleDeleteReport(report.id)}
                            />
                        </span>
                    </div>
                ))}
            </div>
        </>
    );
}

export default ReportsTemplate